import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import SideNav from './../sideNav';
import BackButtonImage from "./../UI-Components/imageComponent";
import { motion } from "framer-motion"
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { 
    logout ,
   dispatchClearLogout, 
   dispatchClearHomeInfo, 
   dispatchClearCurrentAffairs, 
   dispatchClearRegistation, 
   dispatchClearOtp,
   getHomeInfo
} from './../../store/action';
import Home from "@material-ui/icons/Home";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import { Styles } from './../UI-Components/constants';



export const AnimateComponent = ({children}) => (
  <motion.div
    animate={{
      translateX: [40, 10, 0]  
    }}
>{children}</motion.div>
)


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,        
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
        marginLeft:-40,
        color: '#000'
    },
}));

const Header = ( props)  => {
    const {
        title,
    isBackButton,
    menuClick,
    headerRight,
    headerRightClick,
    backButton,
    rightButton,
    headerLeftClick,
    isFromQuiz
    } = props;
    const classes = useStyles();
    const [openDrawer, setOpenDrawer] = useState(false);
    useEffect(() => {
        if(!props.homeData){
          props.getHomeInfo()
        }
      }, [props.homeData])

    return(
        <div className={classes.root}>
            <AppBar position='sticky' 
            // className="bg-gradient"
            style={{backgroundColor: Styles.fiveMantraBgColor}} 
            >
                <Toolbar style={{flex:1 , display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                    {
                        isFromQuiz
                        ?

                        <div></div>
                        :

                        !backButton 
                        ?
                    <IconButton edge="start" className={classes.menuButton} color='#000' aria-label="menu"
                        onClick={() => setOpenDrawer(true)}
                        
                    >
                        <MenuIcon color='#000'/>
                    </IconButton>
                     : <KeyboardBackspaceIcon
                        style={{width: 25, height: 25, cursor: 'pointer', color: '#000'}}
                        onClick={headerLeftClick}
                     />
                    }
                    <AnimateComponent>
                    <Typography variant="h6" className={classes.title}>
                        {title}
                    </Typography>
                    </AnimateComponent>
                    {
                        headerRight 
                        ?
                         <Home
                            onClick={headerRightClick}
                            style={{cursor: 'pointer', color: '#000'}}

                         />
                        : <div></div>
                       
                    }
                </Toolbar>
            </AppBar>
            <SideNav openDrawer={openDrawer} closeDrawer={setOpenDrawer} props={props} />
        </div>
    );
}

const mapStatesToProps = state => {
    return{
        homeData: state.homeData && state.homeData.res && state.homeData.res,
    }
}

export default connect(mapStatesToProps, {
    logout ,
    dispatchClearLogout, 
    dispatchClearHomeInfo, 
    dispatchClearCurrentAffairs, 
    dispatchClearRegistation, 
    dispatchClearOtp,
    getHomeInfo
})(withRouter(Header))
